import React from "react";
import Image from "./Image";

const ImageList = ({ files, removeItemHandle, uploadErrors }) => {
  // render each image by calling Image component
  const renderfile = (file, index) => {
    return (
      <Image
        file={file}
        key={`${file.id}-file`}
        removeItemHandle={removeItemHandle}
        uploadErrors={uploadErrors}
      />
    );
  };

  return files.map(renderfile);
};

export default ImageList;
